export const es = {
    'nav.today': "Resumen de Hoy",
    'nav.calendar': "Calendario de Demanda",
    'nav.rates': "Tarifas y Reglas",
    'nav.automation': "Automatización",
    'nav.audit': "Registro de Auditoría",
    'nav.settings': "Configuración",
    'sidebar.status': "Conectado",
    'stat.occupancy': "Ocupación",
    'stat.adr': "Tarifa Promedio",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Ingresos Est.",
    'stat.trend.vsLastWeek': "vs Sem. Ant.",
    'stat.trend.onPace': "A buen ritmo",
    'dashboard.actions.title': "Acciones Recomendadas",
    'dashboard.actions.empty': "No se encontraron acciones.",
    'filter.all': "Todas",
    'filter.pricing': "Precios",
    'filter.restriction': "Restricciones",
    'action.approve': "Aprobar",
    'action.reject': "Rechazar",
    'action.risk.low': "riesgo bajo",
    'action.risk.medium': "riesgo medio",
    'action.risk.high': "riesgo alto",
    'action.label.current': "Actual",
    'action.label.proposed': "Propuesto",
    'action.metric.impact': "Impacto",
    'action.metric.why': "Por qué",
    'action.status.executed': "Auto-Ejecutado",
    'header.search': "Buscar...",
    'header.logout': "Cerrar Sesión",
    'auto.level.title': "Nivel de Piloto Automático",
    'auto.level.manual': "Manual",
    'auto.level.manual.desc': "Usted aprueba cada recomendación.",
    'auto.level.assisted': "Asistido",
    'auto.level.assisted.desc': "Auto-aprobar riesgo bajo. Revisar cambios mayores.",
    'auto.level.auto': "Totalmente Automático",
    'auto.level.auto.desc': "La IA gestiona precios 24/7 dentro de sus límites.",
    'auto.level.active': "Activo",
    'auto.guardrails.title': "Límites de Seguridad",
    'auto.guardrails.maxIncrease': "Aumento Máx. Diario",
    'auto.guardrails.maxIncrease.desc': "Evitar cambios bruscos.",
    'auto.guardrails.maxDecrease': "Disminución Máx. Diaria",
    'auto.guardrails.maxDecrease.desc': "Evitar precios demasiado bajos.",
    'auto.guardrails.minRate': "Tarifa Mínima",
    'auto.guardrails.minRate.desc': "Nunca vender por debajo de este precio (Netto).",
    'auto.emergency.title': "Control de Emergencia",
    'auto.emergency.label': "Parada de Emergencia",
    'auto.emergency.desc': "Pausar toda la automatización inmediatamente.",
    'auto.emergency.btn': "PAUSAR SISTEMA",
    'rates.filter.all': "Todos los Tipos",
    'rates.filter.next14': "Próximos 14 Días",
    'rates.export': "Exportar",
    'audit.table.time': "Hora",
    'audit.table.actor': "Actor",
    'audit.table.category': "Categoría",
    'audit.table.action': "Acción",
    'audit.table.details': "Detalles",
    'audit.table.status': "Estado",
    'settings.pms.title': "Conexión PMS",
    'settings.pms.connected': "Conectado a",
    'settings.pms.disconnect': "Desconectar",
    'settings.account.title': "Cuenta",
    'settings.account.role': "Rol",
    'settings.restart': "Reiniciar Onboarding",
    'onboard.title': "Conectar PMS",
    'onboard.desc': "Seleccione su sistema de gestión (PMS) para sincronizar.",
    'onboard.connecting': "Conectando...",
    'onboard.connect': "Conectar",
    'onboard.success.title': "¡Configuración Completa!",
    'onboard.success.desc': "**SynthHotel Berlin** está sincronizado.",
    'onboard.success.sub': "Importados 3 tipos de habitación, 14 tarifas y 243 reservas.",
    'onboard.btn.dashboard': "Ir al Dashboard",
    'action.dynamic.weekend.title': "Aumentar Tarifa para Fin de Semana",
    'action.dynamic.weekend.desc': "Ocupación > 75% el Sábado, demanda fuerte (+12 hab. en 24h).",
    'action.dynamic.minstay.title': "Activar Estancia Mín. 2 Noches",
    'action.dynamic.minstay.desc': "Concierto de Taylor Swift. Evitar estancias de 1 noche.",
    'action.dynamic.distress.title': "Bajar Tarifa (Baja Demanda)",
    'action.dynamic.distress.desc': "Ocupación 35% el Martes. Competencia bajó €10.",
    'action.dynamic.gap.title': "Llenar Hueco: Quitar CTA",
    'action.dynamic.gap.desc': "Hueco de una noche. Quitar 'Cerrado a Llegadas' para vender.",
};
